import productsModule from '@/services/productSets';

const _ = require('lodash');
const moment = require('moment');

export default {
  name: 'productCatalog',
  data() {
    return {
      activeTab: 'products',
      summary: null,
      loadingSummary: false,
      refreshing: false,

      products: [],
      loadingProducts: false,
      productFilters: {
        keyword: '',
        status: null,
        isArchived: false
      },
      productPageOptions: {
        pageSize: 25,
        pageNumber: 1,
        total: 0
      },

      collections: [],
      loadingCollections: false,
      collectionFilters: {
        keyword: '',
        isDynamic: null,
        isArchived: false
      },
      collectionPageOptions: {
        pageSize: 25,
        pageNumber: 1,
        total: 0
      },

      selectedProduct: null,
      selectedProductDetail: null,
      loadingProductDetail: false,
      productDrawerVisible: false,

      selectedCollection: null,
      selectedCollectionDetail: null,
      collectionProducts: [],
      collectionProductFilters: {
        keyword: '',
        status: null,
        isArchived: false
      },
      collectionProductPageOptions: {
        pageSize: 10,
        pageNumber: 1,
        total: 0
      },
      loadingCollectionDetail: false,
      loadingCollectionProducts: false,
      collectionDrawerVisible: false,

      statusOptions: [
        { label: 'All', value: null },
        { label: 'In stock', value: 'inStock' },
        { label: 'Out of stock', value: 'outOfStock' }
      ],
      archivedOptions: [
        { label: 'Active', value: false },
        { label: 'Archived', value: true },
        { label: 'All', value: null }
      ],
      collectionTypeOptions: [
        { label: 'All', value: null },
        { label: 'Dynamic', value: true },
        { label: 'Manual', value: false }
      ],
      pageSizeOptions: [10, 25, 50, 100],
      drawerSize: '520px'
    };
  },

  methods: {
    fetchSummary() {
      this.loadingSummary = true;
      return productsModule
        .getCatalogSummary()
        .then((result) => {
          this.summary = result.data;
          this.loadingSummary = false;
        })
        .catch((e) => {
          this.reportError(e);
          this.errorToast('Unable to load product catalog summary.');
          this.loadingSummary = false;
        });
    },

    fetchProducts(isPageLoad) {
      this.loadingProducts = true;
      const params = {
        keyword: this.productFilters.keyword,
        status: this.productFilters.status,
        isArchived: this.productFilters.isArchived,
        pageNumber: this.productPageOptions.pageNumber,
        pageSize: this.productPageOptions.pageSize
      };

      if (!isPageLoad) this.writeQueryToRoute();

      return productsModule
        .listProducts(params)
        .then((result) => {
          this.products = result.data.rows;
          this.productPageOptions.total = result.data.total;
          this.loadingProducts = false;
        })
        .catch((e) => {
          this.reportError(e);
          this.errorToast('Unable to load products.');
          this.loadingProducts = false;
        });
    },

    fetchCollections(isPageLoad) {
      this.loadingCollections = true;
      const params = {
        keyword: this.collectionFilters.keyword,
        isDynamic: this.collectionFilters.isDynamic,
        isArchived: this.collectionFilters.isArchived,
        pageNumber: this.collectionPageOptions.pageNumber,
        pageSize: this.collectionPageOptions.pageSize
      };

      if (!isPageLoad) this.writeQueryToRoute();

      return productsModule
        .listCollections(params)
        .then((result) => {
          this.collections = result.data.rows;
          this.collectionPageOptions.total = result.data.total;
          this.loadingCollections = false;
        })
        .catch((e) => {
          this.reportError(e);
          this.errorToast('Unable to load collections.');
          this.loadingCollections = false;
        });
    },

    fetchProductDetail(product) {
      this.selectedProduct = product;
      this.selectedProductDetail = null;
      this.productDrawerVisible = true;
      this.loadingProductDetail = true;

      return productsModule
        .getProductDetail(product.id)
        .then((result) => {
          this.selectedProductDetail = result.data;
          this.loadingProductDetail = false;
        })
        .catch((e) => {
          this.reportError(e);
          this.errorToast('Unable to load product details.');
          this.loadingProductDetail = false;
        });
    },

    fetchCollectionDetail(collection) {
      this.selectedCollection = collection;
      this.selectedCollectionDetail = null;
      this.collectionProducts = [];
      this.collectionDrawerVisible = true;
      this.loadingCollectionDetail = true;
      this.collectionProductPageOptions.pageNumber = 1;

      productsModule
        .getCollectionDetail(collection.id)
        .then((result) => {
          this.selectedCollectionDetail = result.data;
          this.loadingCollectionDetail = false;
        })
        .catch((e) => {
          this.reportError(e);
          this.errorToast('Unable to load collection details.');
          this.loadingCollectionDetail = false;
        });

      this.fetchCollectionProducts(true);
    },

    fetchCollectionProducts() {
      if (!this.selectedCollection) return;
      this.loadingCollectionProducts = true;

      const params = {
        keyword: this.collectionProductFilters.keyword,
        status: this.collectionProductFilters.status,
        isArchived: this.collectionProductFilters.isArchived,
        pageNumber: this.collectionProductPageOptions.pageNumber,
        pageSize: this.collectionProductPageOptions.pageSize
      };

      return productsModule
        .listCollectionProducts(this.selectedCollection.id, params)
        .then((result) => {
          this.collectionProducts = result.data.rows;
          this.collectionProductPageOptions.total = result.data.total;
          this.loadingCollectionProducts = false;
        })
        .catch((e) => {
          this.reportError(e);
          this.errorToast('Unable to load products for this collection.');
          this.loadingCollectionProducts = false;
        });
    },

    refreshPage() {
      this.refreshing = true;
      const activeFetch = this.activeTab === 'products' ? this.fetchProducts(true) : this.fetchCollections(true);
      Promise.all([this.fetchSummary(), activeFetch]).finally(() => {
        this.refreshing = false;
      });
    },

    onTabChange() {
      this.writeQueryToRoute();
      if (this.activeTab === 'products') {
        this.fetchProducts(true);
      } else {
        this.fetchCollections(true);
      }
    },

    onProductSearch: _.debounce(function () {
      this.resetProductPaginationAndFetch();
    }, 300),

    onCollectionSearch: _.debounce(function () {
      this.resetCollectionPaginationAndFetch();
    }, 300),

    onCollectionProductSearch: _.debounce(function () {
      this.resetCollectionProductPaginationAndFetch();
    }, 300),

    resetProductPaginationAndFetch() {
      this.productPageOptions.pageNumber = 1;
      this.fetchProducts();
    },

    resetCollectionPaginationAndFetch() {
      this.collectionPageOptions.pageNumber = 1;
      this.fetchCollections();
    },

    resetCollectionProductPaginationAndFetch() {
      this.collectionProductPageOptions.pageNumber = 1;
      this.fetchCollectionProducts();
    },

    onProductPageSizeChange() {
      this.productPageOptions.pageNumber = 1;
      this.fetchProducts();
    },

    onProductPageChange(pageNumber) {
      this.productPageOptions.pageNumber = pageNumber;
      this.fetchProducts();
    },

    onCollectionPageSizeChange() {
      this.collectionPageOptions.pageNumber = 1;
      this.fetchCollections();
    },

    onCollectionPageChange(pageNumber) {
      this.collectionPageOptions.pageNumber = pageNumber;
      this.fetchCollections();
    },

    onCollectionProductPageSizeChange() {
      this.collectionProductPageOptions.pageNumber = 1;
      this.fetchCollectionProducts();
    },

    onCollectionProductPageChange(pageNumber) {
      this.collectionProductPageOptions.pageNumber = pageNumber;
      this.fetchCollectionProducts();
    },

    writeQueryToRoute() {
      const query = Object.assign({}, this.$route.query, {
        tab: this.activeTab,
        productKeyword: this.productFilters.keyword || undefined,
        productStatus: this.productFilters.status || undefined,
        productArchived: this.encodeNullableBoolean(this.productFilters.isArchived),
        productPage: this.productPageOptions.pageNumber,
        productPageSize: this.productPageOptions.pageSize,
        collectionKeyword: this.collectionFilters.keyword || undefined,
        collectionDynamic: this.encodeNullableBoolean(this.collectionFilters.isDynamic),
        collectionArchived: this.encodeNullableBoolean(this.collectionFilters.isArchived),
        collectionPage: this.collectionPageOptions.pageNumber,
        collectionPageSize: this.collectionPageOptions.pageSize
      });

      this.$router.replace({ query }).catch(() => {});
    },

    readStateFromRoute() {
      const query = this.$route.query;
      this.activeTab = query.tab === 'collections' ? 'collections' : 'products';
      this.productFilters.keyword = query.productKeyword || '';
      this.productFilters.status = query.productStatus || null;
      this.productFilters.isArchived = this.decodeNullableBoolean(query.productArchived, false);
      this.productPageOptions.pageNumber = this.parsePositiveNumber(query.productPage, 1);
      this.productPageOptions.pageSize = this.parsePositiveNumber(query.productPageSize, 25);
      this.collectionFilters.keyword = query.collectionKeyword || '';
      this.collectionFilters.isDynamic = this.decodeNullableBoolean(query.collectionDynamic, null);
      this.collectionFilters.isArchived = this.decodeNullableBoolean(query.collectionArchived, false);
      this.collectionPageOptions.pageNumber = this.parsePositiveNumber(query.collectionPage, 1);
      this.collectionPageOptions.pageSize = this.parsePositiveNumber(query.collectionPageSize, 25);
    },

    parsePositiveNumber(value, fallback) {
      const parsed = parseInt(value);
      return parsed > 0 ? parsed : fallback;
    },

    encodeNullableBoolean(value) {
      if (value === null || value === undefined) return undefined;
      return value ? 'true' : 'false';
    },

    decodeNullableBoolean(value, fallback) {
      if (value === 'true' || value === true) return true;
      if (value === 'false' || value === false) return false;
      return fallback;
    },

    formatPrice(value) {
      if (value === null || value === undefined || value === '') return 'N/A';
      const currency = this.$store.state.token && this.$store.state.token.currency ? this.$store.state.token.currency : '';
      return currency + Number(value).toLocaleString();
    },

    formatTime(timestamp) {
      if (!timestamp) return 'N/A';
      return moment(timestamp, 'x').format('DD-MMM-YYYY hh:mm A');
    },

    formatCount(value) {
      return Number(value || 0).toLocaleString();
    },

    getStatusType(status) {
      if (status === 'inStock') return 'success';
      if (status === 'outOfStock') return 'info';
      return 'info';
    },

    getStatusLabel(status) {
      if (status === 'inStock') return 'In stock';
      if (status === 'outOfStock') return 'Out of stock';
      return status || 'N/A';
    },

    getArchiveLabel(value) {
      return value ? 'Archived' : 'Active';
    },

    getArchiveType(value) {
      return value ? 'warning' : 'success';
    },

    getCollectionTypeLabel(collection) {
      return collection && collection.is_dynamic ? 'Dynamic' : 'Manual';
    },

    openUrl(url) {
      if (!url) return;
      window.open(url, '_blank');
    },

    updateDrawerSize() {
      if (window.innerWidth < 600) {
        this.drawerSize = '100%';
      } else if (window.innerWidth < 900) {
        this.drawerSize = '90%';
      } else {
        this.drawerSize = '520px';
      }
    },

    updateCollectionDrawerSize() {
      if (window.innerWidth < 600) return '100%';
      if (window.innerWidth < 900) return '90%';
      return '720px';
    },

    getProductEmptyMessage() {
      if (this.productFilters.keyword || this.productFilters.status || this.productFilters.isArchived !== false) {
        return 'No products match the current filters.';
      }
      return 'No products found in the product catalog.';
    },

    getCollectionEmptyMessage() {
      if (this.collectionFilters.keyword || this.collectionFilters.isDynamic !== null || this.collectionFilters.isArchived !== false) {
        return 'No collections match the current filters.';
      }
      return 'No collections found in the product catalog.';
    }
  },

  computed: {
    productDetailProduct() {
      return this.selectedProductDetail && this.selectedProductDetail.product ? this.selectedProductDetail.product : this.selectedProduct;
    },

    productDetailCollections() {
      return this.selectedProductDetail && this.selectedProductDetail.collections ? this.selectedProductDetail.collections : [];
    },

    collectionDetailCollection() {
      return this.selectedCollectionDetail && this.selectedCollectionDetail.collection ? this.selectedCollectionDetail.collection : this.selectedCollection;
    },

    collectionDrawerSize() {
      return this.updateCollectionDrawerSize();
    }
  },

  mounted() {
    this.updateDrawerSize();
    window.addEventListener('resize', this.updateDrawerSize);
    this.readStateFromRoute();
    this.fetchSummary();
    if (this.activeTab === 'products') {
      this.fetchProducts(true);
    } else {
      this.fetchCollections(true);
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateDrawerSize);
  }
};
